// extracted by mini-css-extract-plugin
export default {"popup":"PopupMenu_popup__OSOio","popupMenuItem":"PopupMenu_popupMenuItem__kA5C1","danger":"PopupMenu_danger__4w1Az"};